import { useTranslation } from 'react-i18next';

export function useI18n() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const isEnUS = i18n.language === 'en-US';
  const isJa = i18n.language === 'ja';

  return { t, i18n, isRtl, isEnUS, isJa };
}
